module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f074fd_banner_800x600.001c3466.png";